import React, { useEffect, useState, useRef } from 'react';
import VideoProgressBar from './VideoProgressBar';
import ThronVideo from '@components/utils/ThronVideo';
import '@moncler/scss/components/editorial-video-simplified/component-editorial-video-simplified.scss';
import useBreakpoint from '@utils/useBreakpoint';
import FocusTrap from 'focus-trap-react';
const StandaloneFullVideo = (props) => {
    const currentBreakpoint = useBreakpoint();
    const { eventName, thronid, mobileThronid } = props;
    const [activeThronID, setActiveThronID] = useState(thronid);
    const [active, setActive] = useState(false);
    const activeRef = useRef(false);
    const [playerStatus, setPlayerStatus] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        window.addEventListener(eventName, activateComponent);
        return () => {
            window.removeEventListener(eventName, activateComponent);
        };
    }, []);
    useEffect(() => {
        setActiveThronID(currentBreakpoint <= window.mqObj.sm && mobileThronid ? mobileThronid : thronid);
    }, [currentBreakpoint]);
    useEffect(() => {
        activeRef.current = active; // Ugly workaround, but thron's TS component callbacks are closured
        if (!active) {
            setPlayerStatus(null);
        }
    }, [active]);
    const activateComponent = () => {
        var _a, _b, _c;
        setActive(true);
        (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.add('video-full-screen');
        document.body.style.overflowY = 'hidden';
        (_c = (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.closest('.video-module')) === null || _c === void 0 ? void 0 : _c.classList.add('full-screen');
    };
    const deactivateComponent = () => {
        var _a, _b;
        setActive(false);
        (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('video-full-screen');
        document.body.style.overflowY = 'scroll';
        (_b = videoRef.current.closest('.video-module')) === null || _b === void 0 ? void 0 : _b.classList.remove('full-screen');
    };
    if (!active) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(FocusTrap, null,
        React.createElement("div", { ref: videoRef, className: "video-module__inner-container video-container video-opened" },
            activeThronID && (React.createElement(ThronVideo, { thronID: activeThronID, onTimeUpdate: (playerInstance) => {
                    if (activeRef.current) {
                        setPlayerStatus(playerInstance.status());
                    }
                } })),
            React.createElement("button", { className: "close-icon", onClick: deactivateComponent }),
            React.createElement(VideoProgressBar, { playerStatus: playerStatus, videoRef: videoRef.current, hidden: !active }))));
};
export default StandaloneFullVideo;
